var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformacionNa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.90625C3.5 2.28465 3.86875 1.68851 4.52513 1.24897C5.1815 0.80943 6.07174 0.5625 7 0.5625C7.92826 0.5625 8.8185 0.80943 9.47487 1.24897C10.1313 1.68851 10.5 2.28465 10.5 2.90625C10.5 3.52785 10.1313 4.12399 9.47487 4.56353C8.8185 5.00307 7.92826 5.25 7 5.25C6.07174 5.25 5.1815 5.00307 4.52513 4.56353C3.86875 4.12399 3.5 3.52785 3.5 2.90625ZM0 9.9375C0 9.07324 1.04271 8.375 2.33333 8.375H7C8.29062 8.375 9.33333 9.07324 9.33333 9.9375V20.875H11.6667C12.9573 20.875 14 21.5732 14 22.4375C14 23.3018 12.9573 24 11.6667 24H2.33333C1.04271 24 0 23.3018 0 22.4375C0 21.5732 1.04271 20.875 2.33333 20.875H4.66667V11.5H2.33333C1.04271 11.5 0 10.8018 0 9.9375Z",
    fill: "#C0C1E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformacionNa);
export default __webpack_public_path__ + "static/media/informacionNA.b6e7bd4f80a57c9d8973d7cc216f53ff.svg";
export { ForwardRef as ReactComponent };